export default "__VITE_ASSET__XW8LEW7e__"